import styled from '@emotion/styled';

import { Box, Typography } from '@mui/material';
import BasePageContainer from 'components/views/RegisterValidationComp/PageSuccessAndErrors/BasePageContainer';

import { ReactComponent as IcIturinJump } from 'assets/icons/ic-iturin-jump.svg';

export const ContentReactCodeValid = styled.div(() => `
    padding-bottom: 1.56rem;

    input[type='number'] {
        -moz-appearance: textfield;

        &:disabled {
            color: #0C1C33 !important;
            background-color: white !important;
            border: 1px solid #17A7E0 !important;
        }
    }
    
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    .react-code-input {
        display: flex !important;
        justify-content: space-between;
    }
`);

const ConfirmedToken = () => {
    return (
        <BasePageContainer>
            <Box display='flex' columnGap='.5rem' marginTop='2.4rem' sx={{
                height: { xs: '100%', md: 'fit-content' },
                paddingBottom: { xs: '1.32rem', md: '3rem' },
                alignItems: { xs: 'center', md: 'flex-end' },
                justifyContent: { xs: 'flex-start', md: 'center' },
                flexDirection: { xs: 'column-reverse', md: 'row' },
            }}>
                <IcIturinJump />
                <Box textAlign='center' paddingBottom='1rem'>
                    <Typography fontWeight={700} textTransform='uppercase' sx={{
                        fontSize: { xs: '1.375rem', md: '1.875rem' },
                        paddingBottom: '1rem',
                        'b': {
                            color: 'secondary.main'
                        }
                    }}>
                        TUDO <b>PRONTO!</b>
                    </Typography>
                    <Box border='1px solid' borderRadius='.625rem' borderColor='primary.light' maxWidth='27.2rem' sx={{
                        borderWidth: { xs: '1px', md: '3px' },
                        padding: { xs: '1.67rem 2.4rem', md: '2.56rem 1.75rem' }
                    }}>
                        <Typography sx={{
                            lineHeight: '1.2',
                            fontSize: { xs: '1.125rem', md: '1.5625rem' },
                            'span': { color: 'secondary.main', fontWeight: 700 }
                        }}>
                            Seus dados foram validados e o <br />
                            seu serviço está <span>liberado!</span>
                            <br />
                            <br />
                            Seja bem-vindo a <b>Ituran!</b>
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </BasePageContainer>
    );
}

export default ConfirmedToken;